import { render, staticRenderFns } from "./NewModificationDetails.vue?vue&type=template&id=403a6109&scoped=true&"
import script from "./NewModificationDetails.vue?vue&type=script&lang=js&"
export * from "./NewModificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewModificationDetails.vue?vue&type=style&index=0&id=403a6109&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a6109",
  null
  
)

export default component.exports